import React, { useState, useEffect, useCallback, useMemo } from "react";
import { ToastContainer, toast } from 'react-toastify';
import { /*useDispatch, */useSelector } from 'react-redux';
import Select from 'react-select';

export function AdminLanguages () {
	
	const [ loading, setLoading ] = useState(true);
	const [ error, setError ] = useState(null);
	const [ languages, setLanguages ] = useState([]);
	const [ selectedLanguage, setSelectedLanguage ] = useState(null);
	const [ selectedLanguageName, setSelectedLanguageName ] = useState(null);
	const [ admins, setAdmins ] = useState([]);
	const [ user, setUser ] = useState([]);
	const [ languageDataLoading, setLanguageDataLoading ] = useState(true);
	
	const username = useSelector(state => state.usermangement.username);
	const password = useSelector(state => state.usermangement.password);
	
	const getMyHeaders = useCallback(() => {
		
		let returnValue = new Headers();
		returnValue.append("Content-Type", "application/json");
		
	}, []);
	
	const getRaw = useCallback(() => {
		
		return JSON.stringify({
			"mailaddress": username,
			"password": password
		});
		 
	}, [username, password]);
	
	var myHeaders = useMemo(() => getMyHeaders(), [getMyHeaders]); 
	var raw = useMemo(() => getRaw(), [getRaw]);
	
	useEffect(() => {
		
		document.title = 'Cobtras - Admin languages';
		
		const toastid = toast.loading('Loading data ...');

		var requestOptions = {
  			method: 'POST',
  			headers: myHeaders,
  			body: raw,
  			redirect: 'follow'
		};
		
		fetch("https://cobtras.com/api/v1/signlanguages", requestOptions)
  			.then(response => response.text())
  			.then((result) => {
				
				let resultObj = JSON.parse(result);
				let languages = [];
				
				for(let i = 0; i < resultObj.length; i++){
					
					let languageSelectObj = {
						value: resultObj[i].id,
						label: resultObj[i].name
					}
					
					languages.push(languageSelectObj);
					
				}
				
				setLanguages(languages);
				
				setLoading(false);
				setError(null);
				
				toast.update(toastid, { render: "Successful loaded data", type: "success", isLoading: false, autoClose: 5000 });
					  
			})
			.catch((err) => { 
				
				setError(err.message);
				setLanguages(null);
				
				toast.update(toastid, { render: "Error: " + err, type: "error", isLoading: false, autoClose: 5000 });
				
			});
		
	}, [myHeaders, raw, setError, setLoading]);
	
	function loadAdmins(toastid, successmessage, language){
		
		var requestOptions = {
  			method: 'POST',
  			headers: myHeaders,
  			body: raw,
  			redirect: 'follow'
		};
		
		fetch("https://cobtras.com/api/v1/languageadmins/" + language, requestOptions)
  			.then(response => response.text())
  			.then(result => {
							  
				setAdmins(JSON.parse(result));
								
				setLanguageDataLoading(false);
				setError(null);
				
				toast.update(toastid, { render: successmessage, type: "success", isLoading: false, autoClose: 5000 });
								
			})
		  	.catch((err) => { 
				
				setError(err.message);
				setUser(null);
						
				toast.update(toastid, { render: "Error: " + err, type: "error", isLoading: false, autoClose: 5000 });
					
			});
		
	}
	
	function changeLanguage(language){
		
		setSelectedLanguage(language);
		
		const toastid = toast.loading('Loading data ...');

		var requestOptions = {
  			method: 'POST',
  			headers: myHeaders,
  			body: raw,
  			redirect: 'follow'
		};
		
		fetch("https://cobtras.com/api/v1/user", requestOptions)
  			.then(response => response.text())
  			.then((result) => {
				
				let resultObj = JSON.parse(result);
				let users = [];
				
				for(let i = 0; i < resultObj.length; i++){
					
					let userSelectObj = {
						value: resultObj[i].mailAddress,
						label: resultObj[i].mailAddress + " - " + resultObj[i].firstName + " " + resultObj[i].lastName
					}
					
					users.push(userSelectObj);
					
				}
				
				setUser(users);
				
				fetch("https://cobtras.com/api/v1/languagename/" + language, requestOptions)
  					.then(response => response.text())
  					.then(result => {
							  
						setSelectedLanguageName(result);
						
						loadAdmins(toastid, "Successful loaded data", language);
						
					})
  					.catch((err) => { 
				
						setError(err.message);
						setUser(null);
						
						toast.update(toastid, { render: "Error: " + err, type: "error", isLoading: false, autoClose: 5000 });
					
					});
					  
			})
			.catch((err) => { 
				
				setError(err.message);
				setUser(null);
				
				toast.update(toastid, { render: "Error: " + err, type: "error", isLoading: false, autoClose: 5000 });
				
			});
		
	}
	
	function backToLanguageSelection(){

		setSelectedLanguage(null);
		setAdmins([]);
		setLanguageDataLoading(true);
		
	}
	
	function addUser(user){
		
		const toastid = toast.loading('Adding admin ...');

		var requestOptions = {
  			method: 'POST',
  			headers: myHeaders,
  			body: raw,
  			redirect: 'follow'
		};
		
		fetch("https://cobtras.com/api/v1/setlanguageadmin/" + selectedLanguage + "/" + user, requestOptions)
  			.then(response => response.text())
  			.then(result => {
			
				if(result === "+ OK"){
					loadAdmins(toastid, "Successful added admin", selectedLanguage);
				} else {
					toast.update(toastid, { render: "Error", type: "error", isLoading: false, autoClose: 5000 });
				}
			 
			})
			.catch((err) => { 
				
				setError(err.message);
				setUser(null);
				
				toast.update(toastid, { render: "Error: " + err, type: "error", isLoading: false, autoClose: 5000 });
				
			});
		
	}
	
	function removeUser(user){
		
		const toastid = toast.loading('Removing admin ...');

		var requestOptions = {
  			method: 'POST',
  			headers: myHeaders,
  			body: raw,
  			redirect: 'follow'
		};
		
		fetch("https://cobtras.com/api/v1/deletelanguageadmin/" + selectedLanguage + "/" + user, requestOptions)
  			.then(response => response.text())
  			.then(result => {
			
				if(result === "+ OK"){
					loadAdmins(toastid, "Successful removed admin", selectedLanguage);
				} else {
					toast.update(toastid, { render: "Error", type: "error", isLoading: false, autoClose: 5000 });
				}
			 
			})
			.catch((err) => { 
				
				setError(err.message);
				setUser(null);
				
				toast.update(toastid, { render: "Error: " + err, type: "error", isLoading: false, autoClose: 5000 });
				
			});
		
	}
	
	return (
		<div class="clearfix">
			<div class="detail">
				<h1>Admin languages</h1>
				{loading && <p>Loading data...</p>}
      			{error && (
			        <p>{`There is a problem fetching the post data - ${error}`}</p>
      			)}
      			{!loading &&
      				<>
      					{selectedLanguage == null &&
	      					<>
	      						<h2>Select language for editing rights</h2>
    	  						<Select options={languages} className="select" onChange={e => changeLanguage(e.value)} />
	      					</>
      					}
      					{selectedLanguage != null &&
      						<>
      							{languageDataLoading && <p>Loading data</p>}
								{error && (
			        				<p>{`There is a problem fetching the post data - ${error}`}</p>
      							)}
      							{!languageDataLoading &&
									<>
										<p><button onClick={backToLanguageSelection}>Back</button></p>
										<h2>{selectedLanguageName}</h2>
										{admins.length === 0 &&
											<p>Currently no admins for this language</p>
										}
										{admins.length !== 0 &&
											<p>
												<ul>
													{admins.map((mailAddress) =>
														<li>{mailAddress}&nbsp;&nbsp;&nbsp;<button onClick={() => removeUser(mailAddress)}>Remove</button></li>
													)}
												</ul>
											</p>
										}
										<p>Add user as admin: <Select options={user} className="select" onChange={e => addUser(e.value)} /></p>
									</>
								}
							</>
						}
      				</>
      			}
				<ToastContainer />
			</div>
		</div>
	)
	
}